import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { Provider as CustomStoreProvider } from "store"
import AppRouter from "./AppRouter"
import { StoreProvider } from "easy-peasy"
import { store } from "hooks"
import { ConfigProvider } from "antd"
import locale from "antd/es/locale/pt_BR"
import { createStore, Provider } from "jotai"

import "/node_modules/react-grid-layout/css/styles.css"
import "/node_modules/react-resizable/css/styles.css"
import "antd/dist/antd.css"
import "./styles/index.css"
import "./styles/sass/index.scss"
import "./styles/tailwind.css"
import "config/error.config"
import { logtail } from "lib/logtail"
// import { loadAldeiaFonts } from "hooks/useAldeia"
import { QueryClient } from "react-query"
import { createRoot } from "react-dom/client"

// if (import.meta.env.VITE_ALDEIA === "true") {
//   loadAldeiaFonts()
// }

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // refetchOnMount: false,
      retry: 2,
    },
  },
})

// ReactDOM.render(
//   // <React.StrictMode>
//   <StoreProvider store={store}>
//     <RecoilRoot>
//       <Provider>
//         <Router>
//           <ConfigProvider locale={locale}>
//             <AppRouter />
//           </ConfigProvider>
//         </Router>
//       </Provider>
//     </RecoilRoot>
//   </StoreProvider>,
//   // </React.StrictMode>,
//   document.getElementById("root"),
// )

// Cria um store manual
export const storeJotai = createStore()

const root = createRoot(document.getElementById("root")!)

root.render(
  <StoreProvider store={store}>
    <CustomStoreProvider>
      <Provider store={storeJotai}>
        <Router>
          <ConfigProvider locale={locale}>
            <AppRouter />
          </ConfigProvider>
        </Router>
      </Provider>
    </CustomStoreProvider>
  </StoreProvider>,
)

const WS_ID_MONITORING = ""

window.onerror = (message, source, lineno, colno, error) => {
  try {
    const wsString = localStorage.getItem("workspace")
    let ws

    if (wsString) {
      ws = JSON.parse(wsString)
      if (ws.workspaceId == WS_ID_MONITORING) {
        logtail.error("Unhandled Error", {
          message,
          source,
          lineno,
          colno,
          error: error?.toString(),
        })
      }
    }
  } catch (e) {
    console.log(e)
  }
}

window.onunhandledrejection = (event) => {
  try {
    const wsString = localStorage.getItem("workspace")
    let ws

    if (wsString) {
      ws = JSON.parse(wsString)
      if (ws.workspaceId == WS_ID_MONITORING) {
        logtail.error("Unhandled Promise Rejection", {
          reason: event.reason?.toString(),
        })
      }
    }
  } catch (e) {
    console.log(e)
  }
}
